import { grabSupervisors, grabEmployeeTimesheet, grabUnsubmittedEmployeeTimesheet } from "../dataLayer/supervisorList";
import { TimesheetType } from "../interfaces/TimesheetInterface";

class SupervisorManager {

    // Method to fetch the list of supervisors based on pay period ID and type
    async getSupervisors(payPeriodID: number, type: TimesheetType, adminUserEmployeeID?: number): Promise<any> {
        try {
            // Call the data layer function to grab the list of supervisors
            const authData = await grabSupervisors(payPeriodID, type, adminUserEmployeeID);
            console.log("Grab successful:", authData);
            
            // Return the fetched data
            return authData;

        } catch (error) {
            // Log and re-throw any error that occurs during the fetch process
            console.error("Error during grabbing list:", error);
            throw error;
        }
    }

    async getUnsubmittedEmployeeTimesheet(employeeID: number, payPeriodID: number): Promise<any> {
        try {
            const employeeData = await grabUnsubmittedEmployeeTimesheet(employeeID, payPeriodID);
            console.log("Grab successful:", employeeData);
            
            // Return the fetched data
            return employeeData;

        } catch (error) {
            // Log and re-throw any error that occurs during the fetch process
            console.error("Error during grabbing employee data:", error);
            throw error;
        }
    }

    async getEmployeeTimesheet(employeeID: number, payPeriodID: number): Promise<any> {
        try {
            const employeeData = await grabEmployeeTimesheet(employeeID, payPeriodID);
            console.log("Grab successful:", employeeData);
            
            // Return the fetched data
            return employeeData;

        } catch (error) {
            // Log and re-throw any error that occurs during the fetch process
            console.error("Error during grabbing employee data:", error);
            throw error;
        }
    }
}

// Exporting an instance of SupervisorManager to use throughout the application
export default new SupervisorManager();
